import React, { ReactNode } from 'react';

import AuthLoading from '../Shared/AuthLoading';

export interface IPageWithDataWrapperProps {
  children: ReactNode;
  isLoaded?: boolean;
}

const PageWithDataWrapper = ({ children, isLoaded = false }: IPageWithDataWrapperProps): JSX.Element =>
  isLoaded ? <>{children}</> : <AuthLoading />;

export default PageWithDataWrapper;
